module.exports = __webpack_public_path__ + "static/main4_sp-d16804ccf4d8b519bc896e6bbcf145aa.jpg";